// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID
// };
// export default firebaseConfig;
const firebaseConfig = {
  apiKey: "AIzaSyAeiquY6fCU9tVfva1LVOSsZGKdMrZ7cxc",
  authDomain: "medical-instrument-e-commerce.firebaseapp.com",
  projectId: "medical-instrument-e-commerce",
  storageBucket: "medical-instrument-e-commerce.appspot.com",
  messagingSenderId: "988653250410",
  appId: "1:988653250410:web:01e159adb80b2e54fd6713"
};
export default firebaseConfig